import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Layout.css';

function Layout() {
    const { user, logout } = useAuth();
    const location = useLocation();

    return (
        <div className="layout">
            <header className="header glass">
                <div className="header-content">
                    <Link to="/" className="logo">
                        <span className="logo-icon">✨</span>
                        <span className="gradient-text">Blog Tools</span>
                    </Link>

                    <nav className="nav">
                        <Link
                            to="/"
                            className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
                        >
                            Services
                        </Link>
                        <Link
                            to="/dashboard"
                            className={`nav-link ${location.pathname.startsWith('/dashboard') ? 'active' : ''}`}
                        >
                            Activity Log
                        </Link>
                        <Link
                            to="/blogs"
                            className={`nav-link ${location.pathname.startsWith('/blogs') ? 'active' : ''}`}
                        >
                            Blogs
                        </Link>
                    </nav>

                    <div className="header-right">
                        <div className="user-info">
                            <span className="user-avatar">
                                {user?.name?.charAt(0).toUpperCase() || 'U'}
                            </span>
                            <span className="user-name">{user?.name}</span>
                        </div>
                        <button className="btn-ghost" onClick={logout}>
                            Logout
                        </button>
                    </div>
                </div>
            </header>

            <main className="main-content">
                <Outlet />
            </main>
        </div>
    );
}

export default Layout;
